module.exports = __webpack_public_path__ + "assets/img/1_img7.2b0f5956.png";